<template>
  <div>
    <sidebar></sidebar>
    <navbar :pageIndex="pageIndex"></navbar>
    <home></home>
    <product></product>
    <service></service>
    <contact></contact>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import navbar from "../../components/navbar";
  import product from "./section/product";
  import home from "./section/home";
  import service from "./section/service";
  import contact from "./section/contact";
  import myFooter from "../../components/myFooter";
  import sidebar from "../../components/sidebar";

  export default {
    name: "index",
    data() {
      return {
        pageIndex: 1,
        screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      }
    },
    mounted() {
      if (this.screenWidth < 768) {
        this.$router.push('/mobile')
      }
    },
    components: {
      navbar, product, home, service, contact, myFooter, sidebar
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/home/index.vue